@if (!(loadingPoints$ | async)) {
  <odnr-map [reviewPoints]="wellPoints" [config]="componentData.config" (mapLoaded)="onMapReady($event)"></odnr-map>
} @else {
  Gathering review points... please wait...
}

